import { Component, OnInit, inject } from '@angular/core';
import { CommonModule, ViewportScroller } from '@angular/common';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NewsletterComponent } from '@app/shared/components/newsletter/newsletter.component';

interface TermoSection {
  id: string;
  number: string;
  title: string;
  icon: string;
}

@Component({
  selector: 'app-termos-condicoes',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule, NewsletterComponent],
  templateUrl: './termos-condicoes.component.html',
  styleUrl: './termos-condicoes.component.scss',
})
export class TermosCondicoesComponent implements OnInit {
  private readonly scroller = inject(ViewportScroller);
  private readonly route = inject(ActivatedRoute);

  searchTerm: string = '';
  activeSectionId: string = 'seccao-1';
  dataActualizacao: string = 'Outubro de 2026';

  sections: TermoSection[] = [
    { id: 'seccao-1', number: '1', title: 'Informações da Empresa', icon: 'fa-solid fa-building' },
    { id: 'seccao-2', number: '2', title: 'Objecto e Âmbito', icon: 'fa-solid fa-file-contract' },
    { id: 'seccao-3', number: '3', title: 'Conteúdos Proibidos', icon: 'fa-solid fa-ban' },
    { id: 'seccao-4', number: '4', title: 'Conteúdos do Website', icon: 'fa-solid fa-globe' },
    { id: 'seccao-5', number: '5', title: 'Direitos de Propriedade Intelectual', icon: 'fa-solid fa-copyright' },
    { id: 'seccao-6', number: '6', title: 'Registo Prévio do Utilizador', icon: 'fa-solid fa-user-check' },
    { id: 'seccao-7', number: '7', title: 'Uso de Imagens para Fins Promocionais', icon: 'fa-solid fa-photo-film' },
    { id: 'seccao-8', number: '8', title: 'Responsabilidade e Relação com Promotores', icon: 'fa-solid fa-handshake-angle' },
    { id: 'seccao-9', number: '9', title: 'Sistemas de Pagamentos', icon: 'fa-solid fa-credit-card' },
    { id: 'seccao-10', number: '10', title: 'Investidores e Promotores de Projectos', icon: 'fa-solid fa-users-gear' },
    { id: 'seccao-11', number: '11', title: 'Política de Privacidade', icon: 'fa-solid fa-user-shield' },
    { id: 'seccao-12', number: '12', title: 'Conta de Utilizador e Protecção de Dados', icon: 'fa-solid fa-id-card' },
    { id: 'seccao-13', number: '13', title: 'Cookies e Dados de Navegação', icon: 'fa-solid fa-cookie-bite' },
    { id: 'seccao-14', number: '14', title: 'Resolução de Litígios e Foro', icon: 'fa-solid fa-scale-balanced' },
    { id: 'seccao-15', number: '15', title: 'Disposições Finais', icon: 'fa-solid fa-gavel' },
  ];

  ngOnInit(): void {
    this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        setTimeout(() => {
          this.scrollTo(fragment);
        }, 150);
      }
    });
  }

  scrollTo(sectionId: string): void {
    this.activeSectionId = sectionId;
    const element = document.getElementById(sectionId);
    if (element) {
      const yOffset = -90; // offset for fixed header
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  printDocument(): void {
    window.print();
  }

  copyLink(): void {
    const url = window.location.href;
    navigator.clipboard?.writeText(url);
  }
}
